export const IDO_ACTIVITY_HISTORY_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE =
	'IDO_ACTIVITY_HISTORY_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE';
